export const inputStyles = {
  disabled: {
    opacity: 0.3,
  },
};
